module.exports = __webpack_public_path__ + "img/user_ewallet.c8c91c75.png";